import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.477 15.022a9 9 0 1 0 -7.998 5.965","key":"svg-0"}],["path",{"d":"M12 7v5l3 3","key":"svg-1"}],["path",{"d":"M16 19h6","key":"svg-2"}]]

/**
 * IconClockMinus
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2xvY2stbWludXMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTIwLjQ3NyAxNS4wMjJhOSA5IDAgMSAwIC03Ljk5OCA1Ljk2NSIgLz4KICA8cGF0aCBkPSJNMTIgN3Y1bDMgMyIgLz4KICA8cGF0aCBkPSJNMTYgMTloNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/clock-minus
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconClockMinus = createReactComponent('outline', 'clock-minus', 'ClockMinus', __iconNode);

export default IconClockMinus;